import CreateAccount from 'components/CreateAccount';
import { FormEvent } from 'react';

const NoAccount = () => {
  //To do: functions that creates the account
  const createAccountWithFb = () => {};
  const createAccountWithgmail = () => {};
  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
  };
  return (
    <CreateAccount
      handleCreateAccountWithFb={createAccountWithFb}
      handleCreateAccountWithGmail={createAccountWithgmail}
      handleSubmit={(e) => handleSubmit(e)}
    />
  );
};

export default NoAccount;
